import { Link } from 'react-router-dom';

export function LegalDraftBanner() {
  return (
    <div className="mb-8 rounded-xl border border-amber-500/30 bg-amber-500/10 px-4 py-3 text-amber-200 text-sm">
      <strong className="font-semibold">Interim document.</strong>{' '}
      This is a temporary draft for launch. Formal terms and a privacy policy prepared
      with legal counsel will replace it. If anything here conflicts with your subscription
      or checkout screen, the checkout terms prevail for billing.
    </div>
  );
}

export default function LegalDocument({ title, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-slate-950 text-slate-300">
      <header className="border-b border-slate-800 px-6 py-5">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-4">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90">
            <img src="/propscope-logo.png" alt="PropScope" className="h-10 w-auto" />
            <span className="text-white font-semibold">PropScope</span>
          </Link>
          <Link to="/" className="text-sm text-slate-500 hover:text-slate-300">Home</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-10">
        <h1 className="text-3xl font-bold text-white mb-2">{title}</h1>
        {lastUpdated && (
          <p className="text-slate-500 text-sm mb-6">Last updated: {lastUpdated}</p>
        )}
        <LegalDraftBanner />
        <article className="prose-legal space-y-6 text-sm leading-relaxed">
          {children}
        </article>
        <LegalFooterLinks className="mt-12 pt-8 border-t border-slate-800" />
      </main>
    </div>
  );
}

export function LegalSection({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-semibold text-white mb-2">{title}</h2>
      <div className="space-y-2 text-slate-400">{children}</div>
    </section>
  );
}

export function LegalFooterLinks({ className = '' }) {
  return (
    <p className={`text-center text-slate-500 text-xs space-x-3 ${className}`}>
      <Link to="/terms" className="hover:text-emerald-400">Terms &amp; Conditions</Link>
      <span className="text-slate-700">·</span>
      <Link to="/privacy" className="hover:text-emerald-400">Privacy Policy</Link>
      <span className="text-slate-700">·</span>
      <a href="mailto:info@geekybee.net" className="hover:text-emerald-400">info@geekybee.net</a>
    </p>
  );
}
